import { NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ModalDialogData {
  imageUrl?: string,
  type: 'image' | 'text',
  value?: string,
  fontSize?: string
}

@Component({
  selector: 'app-modal-dialog-image',
  imports: [NgStyle],
  templateUrl: './modal-dialog-image.component.html',
  styleUrl: './modal-dialog-image.component.scss'
})
export class ModalDialogImageComponent {

  data = inject<ModalDialogData>(MAT_DIALOG_DATA);
}
